import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteLeaderListFragment = contentfulGql`#graphql
  fragment EntWebsiteLeaderList on EntWebsiteLeaderList {
    slug,
    headline,
    description,
    leadersCollection(limit: 10) {
      items {
        slug,
        name,
        leaderTitle,
        portrait {
          url
        }
        organization {
          name
          slug
          logo {
            url
          }
          description
        }
      }
    }
  }
`;

export const entWebsiteBlockLeaderListQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteLeaderListFragment}
  query entWebsiteBlockLeaderList($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteLeaderList
      }
    }
  }
`;
